import "$styles/index.css"
// import "../../node_modules/scroll-out/dist/scroll-out.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
